const setLocalUserInfo = (userInfo: any) => {
  localStorage.setItem("userInfo", JSON.stringify(userInfo));
};

const getUserInfo = () => {
  const userInfo = localStorage.getItem("userInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

const setLocalTheme = (theme: string) => {
  localStorage.setItem("theme", theme);
};

const getTheme = () => {
  const theme = localStorage.getItem("theme");
  return theme ?? "light";
};

const setLocalLanguage = (language: string) => {
  localStorage.setItem("language", language);
};

const getLanguage = () => {
  const language = localStorage.getItem("language");
  return language ?? "en";
};

/** Backend expects a UUID; trim and strip accidental quotes from .env or copy-paste. */
const TENANT_UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function normalizeTenantId(raw: string | null | undefined): string | null {
  if (raw === undefined || raw === null) {
    return null;
  }
  const t = String(raw)
    .trim()
    .replace(/^["']+|["']+$/g, "");
  return t.length ? t : null;
}

function isValidTenantUuid(value: string): boolean {
  return TENANT_UUID_RE.test(value);
}

const setLocalTenantId = (tenantId: string) => {
  const n = normalizeTenantId(tenantId);
  if (n && isValidTenantUuid(n)) {
    localStorage.setItem("tenantId", n);
  } else {
    localStorage.removeItem("tenantId");
  }
};

const getTenantId = (): string | null => {
  const n = normalizeTenantId(localStorage.getItem("tenantId"));
  if (!n) {return null;}
  if (!isValidTenantUuid(n)) {
    localStorage.removeItem("tenantId");
    return null;
  }
  return n;
};

/** When URL no longer carries tenant, use env (e.g. VITE_X_TENANTID) if storage is empty. */
export function bootstrapTenantFromEnv(): void {
  if (getTenantId()) {return;}
  const raw =
    (import.meta.env.VITE_DEFAULT_TENANT_ID as string | undefined) ??
    (import.meta.env.VITE_X_TENANTID as string | undefined);
  const n = normalizeTenantId(raw ?? null);
  if (n) {setLocalTenantId(n);}
}
const setLocalAccessToken = (accessToken: string) => {
  localStorage.setItem("accessToken", accessToken);
};

const getAccessToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  return accessToken ?? null;
};

const setLocalRefreshToken = (refreshToken: string) => {
  localStorage.setItem("refreshToken", refreshToken);
};

const getRefreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  return refreshToken ?? null;
};

const clearLocalStorage = () => {
  localStorage.clear();
};

export {
  clearLocalStorage,
  getAccessToken, getLanguage, getRefreshToken,
  getTenantId,
  getTheme, getUserInfo,
  setLocalAccessToken, setLocalLanguage, setLocalRefreshToken,
  setLocalTenantId,
  setLocalTheme, setLocalUserInfo,
};
